import React from 'react'
import { isMobile } from 'react-device-detect'

function Sticky(props) {
  const {
    loading,
    onlyMobile,
    showFirstButton,
    firstButtonText,
    firstButtonIcon,
    firstButtonDisabled,
    firstButtonAction,
    showSecondButton,
    secondButtonText,
    secondButtonIcon,
    secondButtonClass,
    secondButtonValidation,
    secondButtonAction,
  } = props

  let showDesktop = true
  if (onlyMobile) {
    showDesktop = isMobile
  }

  return (
    <>
      {!loading && showDesktop && (
        <div style={{
          position: 'fixed',
          bottom: 0,
          width: !isMobile ? '94.5%' : '100%',
          zIndex: 1000,
          backgroundColor: '#fff',
          padding: '15px',
          borderTop: '1px solid #999999',
        }}>
          <div style={{ display: showFirstButton && showSecondButton ? 'flex' : '', textAlign: 'center' }}>
            {showFirstButton && (
              <button
                style={{ width: '95%', cursor: 'pointer', border: '1px solid grey', marginRight: '5px' }}
                disabled={firstButtonDisabled}
                onClick={firstButtonAction}
                className={`btn btn-default waves-effect waves-light`}
              >
                {firstButtonIcon} {firstButtonText}
              </button>
            )}
            {showSecondButton && (
              <button
                style={{ width: '95%', cursor: 'pointer' }}
                onClick={secondButtonAction}
                disabled={secondButtonValidation}
                className={`btn ${secondButtonClass} waves-effect waves-light`}
              >
                {secondButtonIcon} {secondButtonText}
              </button>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default Sticky
